const types = {
    undefined:"undefined",
    null:"undefined",
    boolean:"boolean",
    number:"number",
    string:"string",
    symbol:"symbol",
    function:"function",
    object:"object",
}
export default types;